import MainView from '@/views/general/MainView'
import ModuleInfoView from '@/views/general/ModuleInfoView'
import PermissionDeniedView from '@/views/general/PermissionDeniedView'

import { DASHBOARD, MODULE_INFO, PERMISSION_DENIED } from '@/routes/general'

export default [
  {
    path: '/',
    name: DASHBOARD,
    component: MainView,
    meta: {
      root: DASHBOARD
    }
  },
  {
    path: '/module-info/:moduleId',
    name: MODULE_INFO,
    component: ModuleInfoView,
    meta: {
      focus: true
    },
    props: true
  },
  {
    path: '/permission-denied',
    name: PERMISSION_DENIED,
    component: PermissionDeniedView,
    meta: {
      titleKey: 'general.permissionDenied.title'
    }
  }
]
